// Stepts for homepage
const talentpoolSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začínáme',
        description: '<b>Tohle je tvá vlastní databáze zajímavých uchazečů, </b> kteří tě už zaujali v minulosti, ale z nějakého důvodu byli zamítnuti. Teď je můžeš snadno oslovit znovu! 👌',
        position: 'center',
        showButtons: true,
    },

},
{
    element: "#filter_with_job-talentpool",
    popover: {
        title: ' ',
        description: '<b>Ve výchozím stavu </b> vidíš všechny uchazeče bez ohledu na pozici.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: '🧑<br>Přehled uchazečů v archivu',
        description: 'Ke každému uchazeči si můžeš přidávat štítky, zkušenosti, ★ hodnocení a vlastní poznámky.',
        position: 'bottom',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);


    }
},
{
    element: ".datatable-td",
    popover: {
        title: '🚀<br> Hromadné akce ',
        description: '<b>Tady lze označit uchazeče, kteří vypadají slibně.</b> Poté můžeš v nabídce dole zvolit "Poslat do Hiringu" a vybraní se objeví mezi aktuálními uchazeči o zaměstnání',
        position: 'right',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);
        $('#onboarding.collapse').collapse('show');

    }


},
// {
//     element: ".align-self-start",
//     popover: {
//         title: '🪄✨<br> Hromadný import uchazečů',
//         description: 'Větší množství uchazečů, např. od personální agentury, lze nahrát <b> z tabulky (Excel nebo CSV).</b> Pokud tedy již máš nějakou vlastní databázi uchazečů, tady ji můžeš nahrát do svého talentpoolu <b>jedním klikem.</b> 🙂',
//         position: 'left-bottom',
//         showButtons: true,
//     },
//
// },


{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Paráda!',
        description: 'Objev, jak ti pomůžeme s onboardingem <br>(4 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Ano, pokračovat dál',
        nextBtnText: 'Rozumím',        // Next button text for this step
        prevBtnText: 'Zpět',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding#guide");

    }
},
]



export default talentpoolSteps
